import * as Sentry from "@sentry/react";
import { useAuthStore } from "@/shared/stores/authStore";
import { BUILD_INFO } from "@/buildInfo";

export function initSentry() {
  if (import.meta.env.PROD) {
    console.log('🔍 [Sentry] Initializing in production mode...');
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          // Replays leave the company boundary. Mask text and media so
          // financial, compensation and CRM data never reach Sentry.
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, // 100% of transactions (for testing - reduce in production)
      // Session Replay
      replaysSessionSampleRate: 0.1, // 10% of healthy sessions; errors are always captured below
      replaysOnErrorSampleRate: 1.0, // 100% of errors

      // Environment
      environment: import.meta.env.MODE,

      // Release tracking
      release: `thriveos@${BUILD_INFO.version}`,

      // User context
      beforeSend(event) {
        // Add user context from authStore
        const user = useAuthStore.getState().effectiveUser;
        if (user) {
          event.user = {
            id: user.uid,
            email: user.email,
            username: user.name,
          };
        }

        return event;
      },
    });
    console.log('✅ [Sentry] Initialized successfully');
  } else {
    console.log('ℹ️ [Sentry] Skipped - not in production mode');
  }
}